import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ImgComponent } from 'shared-components';

import { FullscreenToggleService } from 'app/shared/services/fullscreen-toggle/fullscreen-toggle.service';

@Component({
    selector: 'kh-full-screen-btn',
    templateUrl: './full-screen-btn.component.html',
    styleUrls: ['./full-screen-btn.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ImgComponent]
})
export class FullScreenBtnComponent {
  public constructor(private readonly fullscreenToggler: FullscreenToggleService) {}

  public toggleFullScreen(): void {
    this.fullscreenToggler.toggleFullScreen();
  }
}
